/**
 * Gemeinsame Werte der CSP-Testseite: eine eigene Seite mit durchsetzender CSP
 * und Trusted Types (Konzept, Abschnitt Sicherheit, „Header (Pilot-Kern)“).
 */

/** Adresse der Testseite; nur sie trägt die strenge CSP mit Trusted Types. */
export const CSP_TESTSEITE = '/csp-test';

/** Endpunkt für Verstoßberichte; dahinter steht die Kennung des Prüflaufs. */
export const CSP_BERICHT_PFAD = '/api/csp-bericht';

/** Einzige Trusted-Types-Policy, die die Testseite anlegen darf. */
export const TT_POLICY = 'tfm-test';

/** Gruppe für report-to und den Header Reporting-Endpoints */
export const BERICHT_GRUPPE = 'tfm-csp';

export function istLaufId(wert: unknown): wert is string {
  return typeof wert === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(wert);
}
